import { FC } from "react";
import { DatatableContextProvider } from "@/components/tables/contexts/DatatableContextProvider";
import { AIServicesPageContent } from "./AIServicesPageContent";

export const AIServicesPage: FC = () => (
  <DatatableContextProvider>
    <AIServicesPageContent />
  </DatatableContextProvider>
);
